__webpack_require__.p = "/lottery/";